export default function initAppearOnScrollComponent() {
    var appearOnScrollElements = document.querySelectorAll('.n-appear-d');
    var active = function (entries: IntersectionObserverEntry[]) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('n-inview'); 
            }
            else {
                entry.target.classList.remove('n-inview'); 
            }
        });
    };
    var observer = new IntersectionObserver(active);

    for (var i = 0; i < appearOnScrollElements.length; i++) {
        observer.observe(appearOnScrollElements[i]);
    }
}
